import React from "react";
import { Button, Card, Heading } from "@caesars-ui/core";

const ComponentLinks = ({ 
  storybookUrl, 
  figmaUrl, 
  swiftUIUrl,
  gitlabUrl = "https://gitlab.com/caesars-digital/caesars-ui",
  className = "cui-mt-lg" 
}) => {
  return null;
  
  const platformCards = [];

  // Web/Android Card
  if (storybookUrl) {
    platformCards.push({
      title: "Web/Android",
      content: (
        <div className="cui-flex cui-flex-col cui-gap-sm">
          <Button 
            variant="tertiary" 
            size="sm" 
            onClick={() => window.open(storybookUrl, "_blank")}
            className="cui-w-full"
          >
            View in Storybook
          </Button>
          <Button 
            variant="tertiary" 
            size="sm" 
            onClick={() => window.open(gitlabUrl, "_blank")}
            className="cui-w-full"
          >
            Copy code in GitLab
          </Button>
        </div>
      )
    });
  }

  // iOS Card
  if (swiftUIUrl) {
    platformCards.push({
      title: "iOS",
      content: (
        <div className="cui-flex cui-flex-col cui-gap-sm">
          <Button 
            variant="tertiary" 
            size="sm"
            onClick={() => window.open(swiftUIUrl, "_blank")}
            className="cui-w-full"
          >
            View in Sandbox
          </Button>
          <Button 
            variant="tertiary" 
            size="sm" 
            onClick={() => window.open(gitlabUrl, "_blank")}
            className="cui-w-full"
          >
            Copy code in GitLab
          </Button>
        </div>
      )
    });
  }

  // Figma Card
  if (figmaUrl) {
    platformCards.push({
      title: "Figma",
      content: (
        <Button 
          variant="tertiary" 
          size="sm" 
          onClick={() => window.open(figmaUrl, "_blank")}
          className="cui-w-full"
        >
          View in Figma
        </Button>
      )
    });
  }

  if (platformCards.length === 0) return null;

  return (
    <div className={className}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '1rem', margin: '1rem 0' }}>
        {platformCards.map((card) => (
          <Card 
            key={card.title}
            bg="bg-default" 
            rounded="md" 
            shadow="sm"
            borderColor="fg-minimal"
            className="cui-h-full cui-transition-shadow"
          >
            <div style={{ padding: 'var(--spacing-md)' }}>
              <Heading size="lg" className="cui-text-fg-default cui-mb-md">{card.title}</Heading>
              {card.content}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ComponentLinks;